export const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_a48000de-3dd9-4783-80bb-ba4bb928fb45/artifacts/dbdc2f5d393b2d58_41b32d57-cf11-4713-a588-b35ff7b82798.jpeg";
export const LOGO_MARK_URL = "/logo-mark.png";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1627542557169-5ed71c66ed85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGVzaWduJTIwZGlnaXRhbCUyMHNob3djYXNlfGVufDB8fHx8MTc5MTYxMDA3Nnww&ixlib=rb-4.1.0&q=85",
    studio: "https://images.unsplash.com/photo-1787647560262-ebfcf6c5f979?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwYWdlbmN5JTIwY3JlYXRpdmUlMjBzdHVkaW8lMjBvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc5MTYxMDA3Nnww&ixlib=rb-4.1.0&q=85",
    workspace: "https://images.unsplash.com/photo-1787647559705-d2ad3322020e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwYWdlbmN5JTIwY3JlYXRpdmUlMjBzdHVkaW8lMjBvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc5MTYxMDA3Nnww&ixlib=rb-4.1.0&q=85",
    web: "https://images.unsplash.com/photo-1680016661694-1cd3faf31c3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHx1eCUyMHdlYiUyMGRlc2lnbiUyMGRhc2hib2FyZCUyMHVpfGVufDB8fHx8MTc5MTYxMDA4M3ww&ixlib=rb-4.1.0&q=85",
    design: "https://images.unsplash.com/photo-1658863025658-4a259cc68fc9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxncmFwaGljJTIwZGVzaWduJTIwYnJhbmRpbmclMjBhcnR3b3JrJTIwY2F0YWxvZ3xlbnwwfHx8fDE3OTE2MTAwODN8MA&ixlib=rb-4.1.0&q=85",
    social: "https://images.unsplash.com/photo-1643503640904-75c1a2093570?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxzb2NpYWwlMjBtZWRpYSUyMGNhbXBhaWduJTIwY29udGVudCUyMGNyZWF0aW9ufGVufDB8fHx8MTc5MTYxMDA4M3ww&ixlib=rb-4.1.0&q=85",
    marketing: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHx1eCUyMHdlYiUyMGRlc2lnbiUyMGRhc2hib2FyZCUyMHVpfGVufDB8fHx8MTc5MTYxMDA4M3ww&ixlib=rb-4.1.0&q=85",
    analytics: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxzZW8lMjBhbmFseXRpY3MlMjBncm93dGglMjBzdHJhdGVneSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3OTE2MTAwODN8MA&ixlib=rb-4.1.0&q=85",
};

export const BUSINESS = {
    name: "Innovative Fusion Hives",
    motto: "Where Innovation Thrives",
    ceo: "Peter I. Castillo",
    address1: "4401 Atlantic Ave., Suite 200",
    address2: "Long Beach, CA 90807",
    hours: "Monday - Friday, 9:00 AM - 5:00 PM",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=4401+Atlantic+Ave+Suite+200+Long+Beach+CA+90807",
    mapsEmbed: "https://maps.google.com/maps?q=4401%20Atlantic%20Ave%20Suite%20200%2C%20Long%20Beach%2C%20CA%2090807&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const SERVICES = [
    {
        slug: "web-development",
        name: "Web Development",
        short: "Fast, accessible, conversion-focused websites engineered to grow your business.",
        icon: "Code2",
        accent: "violet",
        image: IMAGES.web,
        cta: "Build My Website",
        overview: [
            "Professional business websites",
            "Responsive website design and development",
            "Landing pages and lead-generation websites",
            "Portfolio and corporate websites",
            "Website maintenance and performance improvements",
            "Search engine optimization fundamentals and technical SEO",
        ],
        benefits: [
            "A website that looks premium and loads fast on every device",
            "Clear conversion paths that turn visitors into inquiries",
            "Technical SEO foundations so customers can find you",
            "A maintainable build you can grow with, not out of",
        ],
        deliverables: ["Discovery and sitemap", "Custom responsive design", "Development and integrations per agreed scope", "On-page and technical SEO setup", "Launch, training, and handover"],
        processNote: "Website features and integrations depend on the agreed project scope, confirmed together during Discovery and Strategy.",
        faqs: [
            { q: "How long does a website take?", a: "Most business websites launch within the timeline agreed during Strategy — typically weeks, not months, depending on scope and content readiness." },
            { q: "Will my site work on phones and tablets?", a: "Yes. Every website we build is responsive by default and tested across mobile, tablet, and desktop viewports." },
            { q: "Can you improve my existing website?", a: "Yes. We offer maintenance, performance improvements, and redesigns. Tell us what is not working and we will propose a scope." },
            { q: "Is SEO included?", a: "Every build includes SEO fundamentals and technical SEO. Ongoing SEO campaigns are part of our Digital Marketing service." },
        ],
    },
    {
        slug: "graphic-design",
        name: "Graphic Design",
        short: "Distinctive brand identities and creative that make your business unforgettable.",
        icon: "Palette",
        accent: "cyan",
        image: IMAGES.design,
        cta: "Create My Brand Identity",
        overview: [
            "Logo design and visual identity",
            "Brand identity systems",
            "Marketing materials",
            "Social media graphics",
            "Advertising creatives",
            "Digital promotional materials",
        ],
        benefits: [
            "A recognizable identity that builds trust at first glance",
            "Consistent creative across every touchpoint",
            "Design systems your whole team can use",
            "Print- and screen-ready files, delivered organized",
        ],
        deliverables: ["Creative direction", "Logo and identity suite", "Brand guidelines", "Marketing and advertising creatives", "Production-ready files"],
        processNote: "Design deliverables are scoped per project — from a single logo to a full identity system — and confirmed before work begins.",
        faqs: [
            { q: "Do I own the final designs?", a: "Yes. Final approved deliverables are handed over with the usage rights defined in your project agreement." },
            { q: "How many logo concepts do I get?", a: "Concept counts and revision rounds are defined in your project scope so expectations stay clear on both sides." },
            { q: "Can you match my existing brand?", a: "Absolutely. We can extend an existing identity or build a new system from scratch." },
            { q: "Do you handle printing?", a: "We prepare print-ready files and can coordinate with your preferred printer as part of the agreed scope." },
        ],
    },
    {
        slug: "social-media-management",
        name: "Social Media Management",
        short: "Strategy, content, and consistency that turn followers into customers.",
        icon: "Share2",
        accent: "amber",
        image: IMAGES.social,
        cta: "Grow My Social Presence",
        overview: [
            "Social media strategy",
            "Content planning and calendars",
            "Creative post and story design",
            "Content publishing and scheduling",
            "Community engagement",
            "Performance reporting",
        ],
        benefits: [
            "A consistent, professional presence without the daily effort",
            "Content planned around your business goals, not guesswork",
            "Scroll-stopping creative built for each platform",
            "Clear reporting on what is working",
        ],
        deliverables: ["Channel strategy", "Monthly content calendar", "Designed posts and stories", "Publishing and scheduling", "Monthly performance report"],
        processNote: "Platform advertising budgets and third-party tool fees are not included unless specified in your service agreement.",
        faqs: [
            { q: "Which platforms do you manage?", a: "We focus on the platforms where your customers actually are — agreed together during strategy." },
            { q: "Do you create the content?", a: "Yes. We design posts and stories and write captions as part of the agreed content plan." },
            { q: "How often will you post?", a: "Posting frequency is defined in your content calendar and service agreement." },
            { q: "Will I see reports?", a: "Yes. Performance reporting is a standard deliverable so you always know what your presence is doing." },
        ],
    },
    {
        slug: "digital-marketing",
        name: "Digital Marketing",
        short: "Data-informed campaigns that turn attention into measurable growth.",
        icon: "TrendingUp",
        accent: "violet",
        image: IMAGES.marketing,
        cta: "Grow My Business",
        overview: [
            "Digital marketing strategy",
            "Paid advertising campaigns",
            "Search engine optimization",
            "Campaign landing pages",
            "Audience targeting and conversion optimization",
            "Analytics and performance reporting",
        ],
        benefits: [
            "Campaigns tied to business outcomes, not vanity metrics",
            "Landing pages purpose-built to convert",
            "Targeting that reaches the right audience",
            "Transparent reporting you can act on",
        ],
        deliverables: ["Marketing strategy", "Campaign setup and management", "Landing pages", "Conversion optimization", "Analytics dashboards and reporting"],
        processNote: "Advertising budgets, platform fees, and third-party costs are billed separately unless specified in your client agreement.",
        faqs: [
            { q: "What budget do I need for ads?", a: "Budgets depend on your market and goals. We recommend a starting point during strategy; ad spend itself is separate from our fees." },
            { q: "How soon will I see results?", a: "Paid campaigns can generate data quickly; SEO compounds over months. We set honest expectations in your strategy." },
            { q: "Do you guarantee rankings or sales?", a: "No credible agency can. We commit to disciplined strategy, transparent reporting, and continuous optimization." },
            { q: "Can you work with my existing accounts?", a: "Yes. We can audit and take over existing ad and analytics accounts or set up new ones." },
        ],
    },
];

export const PROCESS_STEPS = [
    { n: "01", name: "Discovery", text: "We learn your business, audience, and goals so the work solves the right problem." },
    { n: "02", name: "Strategy", text: "We define the approach, scope, and deliverables — clear expectations before any work begins." },
    { n: "03", name: "Design", text: "We develop the visual direction and creative concepts for your review." },
    { n: "04", name: "Development", text: "We build and implement the approved solution — a website, a brand system, or a campaign." },
    { n: "05", name: "Review", text: "We gather your feedback, refine, and test until it is right." },
    { n: "06", name: "Launch", text: "We deliver the approved project and discuss ongoing support." },
];

export const VALUES = [
    { name: "Innovation", text: "We bring fresh thinking to every brief, never recycled templates." },
    { name: "Creativity", text: "Original ideas, crafted with intent and taste." },
    { name: "Collaboration", text: "You are a partner in the process, not a spectator." },
    { name: "Integrity", text: "Honest scopes, honest timelines, honest reporting." },
    { name: "Quality", text: "Details matter. We sweat every one of them." },
    { name: "Measurable Improvement", text: "Work that moves numbers you actually care about." },
];

export const SERVICE_FILTER_OPTIONS = [
    "Web Development",
    "Graphic Design",
    "Social Media Management",
    "Digital Marketing",
    "Multiple Services",
    "Other",
];

export const LEAD_STATUSES = ["New", "Contacted", "Qualified", "Proposal Sent", "Won", "Lost", "Archived"];

export const STATUS_COLORS = {
    New: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    Contacted: "bg-violet-500/15 text-violet-300 border-violet-500/30",
    Qualified: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    "Proposal Sent": "bg-blue-500/15 text-blue-300 border-blue-500/30",
    Won: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    Lost: "bg-rose-500/15 text-rose-300 border-rose-500/30",
    Archived: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};


export const SERVICE_EXTRAS = {
    "web-development": {
        approach: [
            "Every website we build starts with your business goals, not a template. During Discovery we learn who your customers are, what they need to find, and what action you want them to take — then we design a site structure around those answers. The result is a website that works as a business tool: fast to load, easy to navigate, and built to turn visitors into inquiries.",
            "Our web development work in Long Beach and beyond follows modern standards throughout: responsive layouts tested on real phones, tablets, and desktops; accessible markup with semantic headings and alt text; and technical SEO fundamentals — clean URLs, descriptive titles and meta descriptions, sitemaps, and structured data — baked in from the first commit rather than bolted on later. After launch, we stay available for maintenance, performance improvements, and new features as your business grows.",
        ],
        idealFor: [
            "Businesses launching their first professional website",
            "Companies with an outdated or slow site that no longer reflects their brand",
            "Startups and campaigns that need focused landing pages built to convert",
            "Organizations that want a reliable partner for ongoing website maintenance",
        ],
    },
    "graphic-design": {
        approach: [
            "Strong brands are systems, not single logos. We begin every graphic design engagement by understanding your audience, your competitors, and the impression you need to make — then we build a visual identity that holds together everywhere it appears: your website, your social profiles, your printed materials, and your advertising.",
            "Deliverables arrive organized and production-ready, with clear guidelines so anyone on your team can apply the brand consistently. Whether you need a complete identity system or a focused set of marketing creatives, the goal is the same: design that makes your business instantly recognizable and quietly communicates professionalism before a single word is read.",
        ],
        idealFor: [
            "New businesses that need a complete visual identity from day one",
            "Established companies ready for a thoughtful rebrand",
            "Marketing teams that need campaign creative produced to a high standard",
            "Businesses that want social media graphics consistent with their brand",
        ],
    },
    "social-media-management": {
        approach: [
            "Consistent social presence is a system, not a streak of good weeks. We build that system with you: a strategy that ties content to your business goals, clear content pillars, a monthly calendar you can review in advance, and design templates that keep every post unmistakably yours.",
            "Once the system is running, we handle the daily weight — designing posts and stories, writing captions, publishing on schedule, and engaging with your community — while you stay focused on running your business. Every month closes with a plain-language performance report: what reached people, what sparked conversation, and what we will do more of next month.",
        ],
        idealFor: [
            "Business owners who know social matters but lack the hours to do it well",
            "Brands with an inconsistent or dormant presence that needs reviving",
            "Companies preparing a launch, reopening, or seasonal push",
            "Teams that want professional creative and honest reporting without hiring in-house",
        ],
    },
    "digital-marketing": {
        approach: [
            "We treat marketing spend as an investment that must account for itself. Every engagement starts with a strategy tied to a measurable outcome — inquiries, bookings, sales — and every campaign is instrumented so we can see exactly what is working. Paid advertising, search engine optimization, and landing pages are planned together, because traffic without a page built to convert is money left on the table.",
            "You will never hear guaranteed rankings or overnight miracles from us. What you will get is disciplined testing, transparent reporting in plain language, and continuous optimization — audience targeting refined against real data, creatives refreshed before they go stale, and budgets steered toward what demonstrably performs. Advertising budgets and platform fees are always separate from our fees and agreed in writing before anything launches.",
        ],
        idealFor: [
            "Businesses ready to invest in measurable growth rather than guesswork",
            "Local service companies that need to be found by nearby customers",
            "Brands launching products or campaigns that need traffic that converts",
            "Companies that want clear accountability for every dollar of ad spend",
        ],
    },
};